import { render, staticRenderFns } from "./step_banking-security_component_and_resource_base.vue?vue&type=template&id=56aae332&scoped=true"
import script from "./step_banking-security_component_and_resource_base.vue?vue&type=script&lang=js"
export * from "./step_banking-security_component_and_resource_base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aae332",
  null
  
)

export default component.exports